// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__j_teS","notes":"Notes_notes__2rYgz","note":"Notes_note__Q5XQ5","markdown":"Notes_markdown__2lJmk"};